$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-index-component .planning-tab', function () {
    const tabName = $(this).attr('id');
    const parent = $(this).closest('.clients-momentum-planning-index-component');
    const sectionHeader = parent.find('.section #changing-title.section__header h2');

    // AVERY: DELETE 5/1/2025
    // const resourceHeader = parent.find('.section #resources.section__header h2');

    // Change the content of the section header with tab name clicked
    sectionHeader.text(tabName.toUpperCase());
    // resourceHeader.text('RESOURCES');

    // Reattach the underline
    sectionHeader.append("<div class='section__header__underline focused-reanimate'></div>");

    // resourceHeader.append("<div class='section__header__underline focused-reanimate'></div>");
  });


// ADDING NOTE ON ANY TAB
$(document).on('click', '.component .momentum-dash-submit-btn-js', function (e) {
    e.preventDefault();
    const noteForm = $(this).closest('.note-form-js');
    // read from the hidden input that Trix updates
    const $input= noteForm.find('input.new-note-field');
    const note = $input.val() || '';
    const attributeHolder = noteForm.find('.hidden-attribute-div');
    const hsContactId= attributeHolder.attr('hs_contact_id');
    const brandId = attributeHolder.attr('brand_id');
    const section= attributeHolder.attr('section');
    const noteFrom= attributeHolder.attr('note_from');

    $.post('/components/clients/playbooks/playbook/client_notes', {
        brand_id: brandId,          // can be blank
        hs_contact_id: hsContactId,
        note: note,                 // HTML from Trix
        section: section,
        note_from: noteFrom
    }).done(function () {
            // Find the note form, reset it, and
            const inputId = $input.attr('id');
            $input.val('');
            const $editor = noteForm.find(`trix-editor[input="${inputId}"]`);
            if ($editor.length) { $editor[0].editor.loadHTML(''); }
            // show a small saved tag -- hide after 5 seconds
            noteForm.find('.small-saved-tag').removeClass('d-none');
            setTimeout(function () {
                noteForm.find('.small-saved-tag').addClass('d-none');
            }, 5000);
        }).fail(function (response) {
            const data = response.responseJSON;
            if (data && data.success === false) {
                alert('There was an issue saving your Note, if the issue persists, let us know.');
            } else {
                alert('Error saving note.');
            }
        });
    });
});

// Function used to update the confirmation day readiness assessment component
window.reloadConfirmationDayReadinessAssessmentComponent = function reloadConfirmationDayReadinessAssessmentComponent() {
  $('.clients-momentum-life-on-your-terms-progress-component').each(function () {
    const componentBase = $(this).closest('.component-base');
    reloadComponent(componentBase.length ? componentBase : $(this));
  });
};

window.reloadClientTaskBinComponents = function reloadClientTaskBinComponents() {
  $('.clients-momentum-task-summary-component').each(function () {
    const componentBase = $(this).closest('.component-base');
    reloadComponent(componentBase.length ? componentBase : $(this));
  });

  $('.clients-client-task-bin-component').each(function () {
    const componentBase = $(this).closest('.component-base');
    reloadComponent(componentBase.length ? componentBase : $(this));
  });
};

// Function used to update the momentum section tabs when a section component is clicked
window.reloadMomentumSectionPlanningTab = function reloadMomentumSectionPlanningTab(completion_percentage, tab_name) {
  // Gets the tab for the momentum section header
  const tab = $('.momentum-section-tab-js[section_name=' + tab_name + ']');

  const completed = completion_percentage >= 99.9;

  if (completed) {
    // Mark tab completed
    tab.addClass('complete');

    // Remove the progress meter
    tab.find('.progress-meter-container-js').addClass('d-none');
  } else {
    // Mark tab incomplete
    tab.removeClass('complete');

    // Add the progress meter
    tab.find('.progress-meter-container-js').removeClass('d-none');

    // Update the progress meter bar and label
    tab.find('.progress-meter-js').css('width', completion_percentage + '%');
    tab.find('.progress-label-js').text(completion_percentage + '%');
  }
};
